<div class="w-full" [ngClass]="{
    'rounded-sm': rounded === 'sm',
    'rounded-md': rounded === 'md',
    'rounded-lg': rounded === 'lg',
    'rounded-xl': rounded === 'xl',
    'rounded-full': rounded === 'full',
}">
  <div class="divide-y divide-gray-200 border border-gray-200 dark:divide-neutral-700 dark:border-neutral-700" [ngClass]="{
    'rounded-sm': rounded === 'sm',
    'rounded-md': rounded === 'md',
    'rounded-lg': rounded === 'lg',
    'rounded-xl': rounded === 'xl',
    'rounded-full': rounded === 'full',
  }">
    @for (item of items; track item.id) {
      <ng-content></ng-content>
    }
  </div>
</div>
